// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__P1Tu8"};